'use client';
import { FunctionComponent, useEffect, useState } from 'react';
import ButtonLink, { ButtonLinkProps } from '../../../components/ButtonLink';
import { useGetUtmsAsUrlString } from '../../../hooks/useUtms';
import { useAnalytics } from '../../../hooks/Analytics/useAnalytics';

export type BookDemoButtonLinkProps = Omit<ButtonLinkProps, 'href'>;

const CALENDLY_URL = 'https://calendly.com/adrianbinzaru/lets-chat';

export const BookDemoButton: FunctionComponent<BookDemoButtonLinkProps> = (props) => {
    const [utmsString, setUtmsString] = useState('');
    const getUtms = useGetUtmsAsUrlString();
    const Analytics = useAnalytics();

    useEffect(() => {
        const utms = getUtms();
        setUtmsString(utms);
    }, [getUtms]);

    return (
        <ButtonLink
            href={CALENDLY_URL + utmsString}
            target="_blank"
            rel="noopener noreferrer"
            preset="secondary"
            {...props}
            onClick={() => {
                Analytics.record.event('Book a Demo Button Clicked', {});
            }}
        >
            Book a Call
        </ButtonLink>
    );
};
